var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeypagoShortLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7633 10.7194L6.26185 6.51039C6.00374 6.26561 5.61621 6.25031 5.61621 6.57158V22.2435C5.61621 22.5651 6.00374 22.6416 6.26185 22.3812L10.7633 18.1573C10.8341 18.096 10.8744 18.0138 10.8756 17.9278V10.9492C10.8745 10.8631 10.8342 10.7807 10.7633 10.7194Z",
    fill: "#4B5563"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2353 5.6374H23.1604C23.2406 5.63514 23.3198 5.65312 23.388 5.68906C23.4562 5.72501 23.5105 5.77733 23.544 5.83946C23.5775 5.90158 23.5887 5.97075 23.5762 6.03828C23.5637 6.10581 23.5281 6.1687 23.4738 6.21905L15.026 14.2695C14.9633 14.3341 14.929 14.4153 14.929 14.4992C14.929 14.583 14.9633 14.6642 15.026 14.7288L23.4185 22.7789C23.4708 22.8298 23.5048 22.8925 23.5162 22.9595C23.5277 23.0265 23.5161 23.0948 23.483 23.1563C23.4498 23.2178 23.3965 23.2698 23.3294 23.3061C23.2624 23.3423 23.1844 23.3613 23.105 23.3606H13.2536C13.1985 23.3621 13.1437 23.3541 13.0923 23.3371C13.0409 23.3201 12.994 23.2945 12.9544 23.2618C12.9149 23.2291 12.8834 23.19 12.8619 23.1467C12.8405 23.1035 12.8294 23.057 12.8294 23.01V5.98958C12.8272 5.94335 12.8361 5.89722 12.8556 5.85404C12.8751 5.81086 12.9048 5.77155 12.9428 5.73854C12.9808 5.70553 13.0264 5.67952 13.0767 5.66212C13.1271 5.64472 13.181 5.63631 13.2353 5.6374Z",
    fill: "#4B5563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeypagoShortLogo);
export default __webpack_public_path__ + "static/media/keypago-short-logo.863e34bd86f0b9961b16f8054b364174.svg";
export { ForwardRef as ReactComponent };